import { render, staticRenderFns } from "./Login.Finish.vue?vue&type=template&id=2b19fcc8&scoped=true&"
import script from "./Login.Finish.vue?vue&type=script&lang=js&"
export * from "./Login.Finish.vue?vue&type=script&lang=js&"
import style0 from "./Login.Finish.vue?vue&type=style&index=0&id=2b19fcc8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b19fcc8",
  null
  
)

export default component.exports